require('./files/contact');

require('../../sass/web/contact.scss');
require('../../sass/web/modal.scss');